var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",class:{
         ['button_size_'+_vm.size]: !!_vm.size,
         'button_size_large' : !_vm.size,
         'button_type_disabled': _vm.disabled,
         'button_type_loading': _vm.loading
     },attrs:{"disabled":_vm.disabled || _vm.loading},on:{"click":function($event){return _vm.$emit('click',$event)}}},[_c('span',[_vm._t("default")],2),_c('transition',{attrs:{"name":"button_preloader"}},[(_vm.loading)?_c('v-preloader',{staticClass:"preloader_type_button",attrs:{"size":"ex-small"}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }